interface ThematicNotFoundProps {
    title: string;
    message: string;
}

export default function ThematicNotFound({ title, message }: ThematicNotFoundProps) {
    return (
        <div className="m-8 min-h-[40vh] md:mx-28 md:my-10">
            <div className="rounded-xl border border-gray-200 bg-white p-8 text-center dark:border-gray-700 dark:bg-gray-900">
                <h1 className="mb-3 text-3xl font-bold text-darkBlue dark:text-lightBlue">{title}</h1>
                <p className="text-default-600 dark:text-default-400">{message}</p>
            </div>
        </div>
    );
}
